import type { Map as FleetGLMap } from "maplibre-gl";
import truckAsset from "../../assets/fleet/realistic-container-truck.png";
import runningAsset from "../../assets/fleet/realistic-container-truck-running.png";
import idleAsset from "../../assets/fleet/realistic-container-truck-idle.png";
import offlineAsset from "../../assets/fleet/realistic-container-truck-offline.png";
import { fleetColors } from "./fleetMapLayers";

// Container paint is generated per status; the cab stays white in every asset.
export const truckAssets: Record<keyof typeof fleetColors,string> = {
  running:runningAsset,idle:idleAsset,halted:truckAsset,unknown:offlineAsset,stale:offlineAsset,
};
const highlights: Record<keyof typeof fleetColors,string> = {
  running:"#28b879",idle:"#eda63a",halted:"#ee5957",unknown:"#94a3b8",stale:"#94a3b8",
};

export function createRealisticTruckIcon(image: CanvasImageSource, status: keyof typeof fleetColors): ImageData | undefined {
  const canvas=document.createElement("canvas");
  canvas.width=160;canvas.height=256;
  const context=canvas.getContext("2d");
  if(!context) return;
  const color=highlights[status];
  // The source is a vertical transparent sprite with the cab facing north.
  const source=image as HTMLImageElement;
  const width=source.naturalWidth || source.width;
  const height=source.naturalHeight || source.height;
  if(!width || !height) return;
  const scale=Math.min(140/width,236/height);
  const drawWidth=width*scale,drawHeight=height*scale*.85;
  const x=(canvas.width-drawWidth)/2,y=(canvas.height-drawHeight)/2;
  context.imageSmoothingEnabled=true;context.imageSmoothingQuality="high";
  context.shadowColor=color;context.shadowBlur=10;context.shadowOffsetX=0;context.shadowOffsetY=0;
  context.drawImage(image,x,y,drawWidth,drawHeight);
  context.shadowColor="transparent";
  // A soft pool of status light stays behind the chassis.
  context.globalCompositeOperation="destination-over";
  const glow=context.createRadialGradient(80,145,7,80,145,58);
  glow.addColorStop(0,color+"70");glow.addColorStop(.6,color+"36");glow.addColorStop(1,color+"00");
  context.fillStyle=glow;context.beginPath();context.ellipse(80,145,53,60,0,0,Math.PI*2);context.fill();
  return context.getImageData(0,0,canvas.width,canvas.height);
}

export async function loadRealisticTruckIcons(map: FleetGLMap,isActive:()=>boolean): Promise<boolean> {
  try {
    const urls=Array.from(new Set(Object.values(truckAssets)));
    const loaded=await Promise.all(urls.map(async url=>({url,image:await map.loadImage(url)})));
    if(!isActive()) return false;
    const images=new Map(loaded.map(item=>[item.url,item.image.data]));
    const icons=(Object.keys(fleetColors) as (keyof typeof fleetColors)[]).map(status=>({status,image:createRealisticTruckIcon(images.get(truckAssets[status])!,status)}));
    if(icons.some(icon=>!icon.image) || !isActive()) return false;
    icons.forEach(icon=>map.addImage("fleet-realistic-"+icon.status,icon.image!,{pixelRatio:2}));
    return true;
  } catch {
    // Preserve the existing vector trucks if the local asset cannot load.
    return false;
  }
}
